import { SVGProps, Ref, forwardRef } from 'react';

export const BusTaxiFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 21.08c0 .857 0 1.286-.13 1.628-.203.536-.626.96-1.162 1.162-.342.13-.771.13-1.629.13-.766 0-1.15 0-1.468-.11a2 2 0 0 1-1.14-1.006c-.122-.25-.177-.554-.245-1.082-1.166.147-2.56.198-4.226.198-1.667 0-3.061-.051-4.227-.198-.068.528-.122.832-.245 1.082a2 2 0 0 1-1.14 1.006c-.317.11-.7.11-1.467.11-.858 0-1.287 0-1.629-.13a2 2 0 0 1-1.162-1.162C2 22.366 2 21.937 2 21.079V13.3h20zM6.75 15.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m10.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.8 17.65h4.4v-1.8H9.8z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 0c8.75 0 10 1.375 10 11v.5H2V11C2 1.375 3.25 0 12 0M9.3 6.2V8h1.8V6.2zm3.6 0V8h1.8V6.2zM7.5 4.4v1.8h1.8V4.4zm3.6 0v1.8h1.8V4.4zm3.6 0v1.8h1.8V4.4z"
            fill="currentColor"
        />
    </svg>
));
BusTaxiFilledSize24Glyph.displayName = 'BusTaxiFilledSize24Glyph';
